import { Component, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterOutlet } from '@angular/router';
import { LoadingFullscreenComponent } from '../loading-fullscreen/loading-fullscreen.component';
import { LoadingFullscreenService } from '../../services/loading-fullscreen.service';
import { ToastModule } from 'primeng/toast';
import { AsyncPipe } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CookiesStore } from '../../store/cookies.store';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [HeaderComponent, RouterOutlet, LoadingFullscreenComponent, ToastModule, ConfirmDialogModule, FooterComponent, DialogModule, ButtonModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  providers: [],
})
export class LayoutComponent {
  router = inject(Router);
  loading$ = inject(LoadingFullscreenService).loading$;
  cookiesStore = inject(CookiesStore)

  ngOnInit() {
  }

  handleCookieAction(userAction: boolean){
   this.cookiesStore.setCookieDialogVisiblity(false);
    if (userAction) {
      localStorage.setItem('REVE-cookies', 'true');
      this.cookiesStore.setCookie(true);
    } else {
      localStorage.setItem('REVE-cookies', 'false');
            this.cookiesStore.setCookie(false);

    }

  }
}
